import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 36 36"
      fill="none"
    >
      <g clipPath="url(#render-sample-a)">
        <g filter="url(#render-sample-b)">
          <path
            fill="url(#render-sample-c)"
            fillRule="evenodd"
            d="M15.002 3.6h5.457c1.05 0 1.994.553 2.519 1.448l2.067 3.592h.939a6.232 6.232 0 0 1 6.236 6.23v12.018a6.232 6.232 0 0 1-6.236 6.232H9.476a6.232 6.232 0 0 1-6.236-6.232V14.871A6.232 6.232 0 0 1 9.476 8.64h.939l2.068-3.592A2.906 2.906 0 0 1 15 3.6Z"
            clipRule="evenodd"
            shapeRendering="crispEdges"
          />
        </g>
        <g filter="url(#render-sample-d)">
          <path
            fill="url(#render-sample-e)"
            d="M16.088 13.098a7.824 7.824 0 0 0-5.98 5.258h7.264c.15.003.297.018.44.047l-1.723-5.305Zm3.483 6.819c.061.17.104.349.125.535l4.718-3.427a7.8 7.8 0 0 0-4.445-3.68 7.819 7.819 0 0 0-2.658-.382l2.26 6.954Zm-.829 2.716 6.177-4.487a7.798 7.798 0 0 1 .076 5.064 7.794 7.794 0 0 1-1.912 3.12l-4.754-3.454a2.41 2.41 0 0 0 .384-.222l.013-.01.017-.011Zm-2.81-.01a2.376 2.376 0 0 1-.332-.299l-1.744 5.37c.4.214.826.395 1.274.541a7.819 7.819 0 0 0 7.01-1.102l-6.21-4.51h.001ZM9.816 19.56h5.465a2.349 2.349 0 0 0-.18.404l-2.295 7.057a7.84 7.84 0 0 1-2.99-7.461Z"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="render-sample-c"
          x1={17.73}
          x2={22.892}
          y1={3.6}
          y2={33.212}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF6FF" />
          <stop offset={1} stopColor="#ACD7FF" stopOpacity={0.78} />
        </linearGradient>
        <linearGradient
          id="render-sample-e"
          x1={9.72}
          x2={25.5}
          y1={12.96}
          y2={13.082}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00B2FF" />
          <stop offset={1} stopColor="#0047FF" />
        </linearGradient>
        <filter
          id="render-sample-b"
          width={36.98}
          height={37.52}
          x={-0.76}
          y={-0.4}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.197999 0 0 0 0 0.478402 0 0 0 0 0.816667 0 0 0 0.57 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5464_1051"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_5464_1051"
            result="shape"
          />
        </filter>
        <filter
          id="render-sample-d"
          width={19.66}
          height={19.66}
          x={7.72}
          y={11.96}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.00392157 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 0.37 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5464_1051"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_5464_1051"
            result="shape"
          />
        </filter>
        <clipPath id="render-sample-a">
          <path fill="#fff" d="M0 0h36v36H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
